import NationalHealthServiceHR from "./NationalHealthServiceHR";

export default {
    NationalHealthServiceHR
};
